export enum WorkflowDesignerViews {
    GraphView = 'graph-view',
    TableView = 'table-view',
    ResultsView = 'results-view',
}
